import config from '@/Constants';
import { HttpStatusCode } from '@/modules/shared/data/protocols/http';
import { UnexpectedError } from '@/modules/shared/domain/errors';
import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import snakeToCamel from '@/utils/snakeToCamel';

import { CommentMedia } from '../interfaces';

const url = config.DISCUSSION_COMMENT_MEDIAS_URL;

export interface RetryCommentMediaInput {
  commentId: string;
  content: string;
  fileName: string;
  fileSize?: number;
}

export const retryCommentMedia = async (
  params: RetryCommentMediaInput,
): Promise<CommentMedia> => {
  const { statusCode, body } = await AxiosHelper.post({
    url,
    body: {
      discussion_comment_id: params.commentId,
      content: params.content,
      file_name: params.fileName,
      // Ghosts antigos (localStorage) podem não ter fileSize — omitido nesse caso.
      ...(params.fileSize !== undefined && { file_size: params.fileSize }),
    },
  });

  if (statusCode === HttpStatusCode.noContent) {
    return snakeToCamel(body);
  }
  if (Array.isArray(body?.error_messages) && body.error_messages.length) {
    throw new Error(body.error_messages.join(', '));
  }
  throw new UnexpectedError();
};
